<template>
  <Tabs
    :value="tab"
    @input="$ev => $emit('tab:change', $ev)"
    :items="items"
    theme="border"
    class="dashboard-statistics"
    force-header
  >
    <template v-slot:[tab]>
      <component v-if="settings" :is="settings.component" v-bind="settings.props">
        <template v-if="!item.demo" #footer>
          <router-link :to="{ name: 'analytics-external', query: { type } }">{{ $t('showDetails') }}</router-link>
        </template>
      </component>
    </template>
  </Tabs>
</template>

<script>
import moment from 'moment'
import Bus from '@/bus'

import StatisticsSalesResidentials from '@/components/Statistics/Sales/Residentials'
import Analytics from '@/components/Analytics'
import Tabs from '@/components/Tabs'
import { DropdownComponent } from 'vue-elder-dropdown'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'project',
    },
    tab: {
      type: String,
      default: 'analytics',
    },
    items: {
      type: Array,
      default: () => [],
    },
    range: {
      type: Object,
      default: () => ({
        start: moment().startOf('year'),
        end: moment().endOf('year'),
      }),
    },
    addons: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    settings() {
      if (!this.item.url) return
      switch (this.tab) {
        case 'analytics':
          return {
            component: Analytics,
            props: {
              filter: {
                id: this.item.id,
                preset: 'monthly_pageviews',
                context: this.type,
              },
            },
          }
        case 'sales.residentials':
          return {
            component: StatisticsSalesResidentials,
            props: {
              project: this.id,
            },
          }
      }
    },

    filter() {
      return {
        range: this.range,
      }
    },
  },
  methods: {
    chat(value, tag) {
      Bus.$emit('chat', `${tag ? tag + ' - ' : ''}${this.$t('upsaleRequestTemplate', [value])} - ${this.item.name}`)
    },
  },
  components: {
    StatisticsSalesResidentials,
    Analytics,
    Tabs,
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.dashboard-statistics {
  height: 100%;

  .analytics {
    height: 100%;

    .card__content {
      padding-top: 1rem;
    }
  }

  .elder-choices {
    margin-bottom: 0;

    &__item {
      flex-grow: 0;

      &-label {
        font-size: 0.9em;
        padding: 0.4rem 1rem;
      }
    }
  }

  &__upsell {
    &-item {
      white-space: normal;

      &__sublabel {
        opacity: 0.5;
        display: block;
      }

      .elder-button__label {
        width: 40ch;
      }
    }
  }
}
</style>
